// rm-home.js — entry screen.
//
// Mirrors `Assets/_App/UI/Screens/HomeScreen.cs`. Title, language toggle, a
// big "Start" button that drills into the root list. This file is a SCAFFOLD
// STUB — the real wiring lives in a future brief.

import { RMComponent } from "../core/component.js";
import { html } from "../core/html.js";
import { navigate } from "../router.js";
import { INTRO_SEEN_KEY } from "./rm-intro.js";

export class RMHome extends RMComponent {
  static styles = `
    :host { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 2rem; gap: 1.5rem; min-height: 100%; box-sizing: border-box; text-align: center; }
    h2 { margin: 0; font-size: 2rem; }
    p { margin: 0; color: var(--rm-muted); max-width: 32rem; }
    .start { padding: 0.75rem 1.5rem; background: var(--rm-accent); color: var(--rm-bg); border: none; border-radius: 0.5rem; font-size: 1rem; cursor: pointer; }
    .start:hover { filter: brightness(1.1); }
  `;

  // Start → play the Speech Genie intro once per session, then the menu.
  // The click is the user gesture the intro video needs to play with sound
  // (and to unlock iOS Safari audio for the rest of the session), so route
  // straight to /intro synchronously here. On later Starts in the same
  // session the intro is already seen, so go directly to the menu.
  _start = () => {
    let seen = false;
    try { seen = sessionStorage.getItem(INTRO_SEEN_KEY) === "1"; } catch {}
    navigate(seen ? "/list/root" : "/intro");
  };

  render() {
    return html`
      <h2>Rhythmic Mandarin</h2>
      <p>Listen and learn through the rhythms of Mandarin Chinese. Tap Start to begin.</p>
      <button class="start" on:click=${this._start}>Start</button>
    `;
  }
}
